"use strict";

var Backbone                = require("backbone");
var ReaderView              = require("./views/reader-view");
var $                       = require("jquery");

// Router
var Router = Backbone.Router.extend({

    routes: {
        "(/):publication_id/:document_id/:page"     : "reader",
        "(/):publication_id/:document_id"           : "reader",
        "(/):page"                                  : "readerPage",
        "(/)"                                       : "readerPage",
        "*error"                                    : "error404"
    },

    initialize: function(options){
        this.app=options.app;
    },

    readerPage: function(page) {
        this.reader(null,null,page);
    },

    reader: function(publication_id,document_id,page) {
        
        var route_template;

        if(this.view){
            this.view.close(); //close previous view
        }

        if(!page){
            page=1;
        }

        if(this.app.publicationId&&this.app.documentId){
            // on écrase les paramètres du hash par les paramètres passés par le js
            publication_id=this.app.publicationId;
            document_id=this.app.documentId;
            route_template="<%=page%>";
        }
        else{
            route_template="<%=publicationId%>/<%=documentId%>/<%=page%>";
        }

        this.view = new ReaderView({
            app:this.app,
            publicationId:publication_id,
            documentId:document_id,
            page:page,
            routeTemplate:route_template
        });

        $(this.app.el).html(this.view.render().el); // replace dom

    },

    error404:function(xxx){
        console.error("'"+xxx+"' is not a recognized route");
    },

    close:function(){
        if(this.view){
            this.view.close(); //close previous view
            this.view=null;
        }
    }
});

 module.exports = Router;


//////////////////
// WEBPACK FOOTER
// ./src/router.js
// module id = 16
// module chunks = 0